/*
 * @Autor: xx
 * @Version: 1.0
 * @Date: 2019-11-19 17:44:00
 * @LastEditors: xx
 * @Description:
 * @LastEditTime: 2021-08-02 15:29:07
 */
import { getDictItemAllList } from "./api-basic";
import config from "@/config/config";
import { objAny } from "@/common/common-interface";
/**
 * 获取字典用的 KEYk
 */
export const optionKey = {
  auxPowerList: "104", //辅助电源
  devTypeList: "102", //充电桩类别
  innerIdList: "185", //充电桩接口标准
  pushStatusList: "103", //推送状态
  httpList: "107", //对接方式
  getList: "108", //请求方式
  spearTypeList: "1018", //接口类型
  clientList: "1017", //客户名称
  isShowObj: "1019", //公众号显示
  networkObj: "1020", //联网状态
  autotrophyObj: "156", //运营属性
  csTypeObj: "154", //充电站类型
  suppoertOrderObj: "1021", //支持预约
  allDayDisparkObj: "1022", //全天开放
  freeParkObj: "1023", //免费停车
  paymentObj: "1024", //支付方式
  messageTypeList: "1030", //短信类型
  cardStatusList: "159", //sim 卡运行状态
  provideList: "160", //sim 供应商
  simCardFlowList: "1031", //sim 套餐
  cardStatusObj: "1033", //sim 状态
  roleTypeObj: "1069", //角色类型
  netStatusObj: "12366", //互通状态
  netDriectionObj: "12367", //互通方向
  authObj: "12376", //菜单权限
  userTypeObj: "12365", //系统用户类型
  noticeStatusObj: "12382", //系统用户类型
  noticeTypeObj: "12363", //系统用户类型
  fileTypeObj: "12427", //模板文件类型
  businessTypeObj: "12428", //模板文件业务类型
  smsAuditStatusObj: "12430", // 短信审核状态
  purchasedWayObj: "12431", // 购买方式
  wxBussType: "12371", //微信模版ID集合
  alarmLevelObj: "12455", //告警等级
  alarmTypeObj: "12456", //告警类型
  responsibilityTypeObj: "12457", //批量新增充电桩停止原因
  productionStatus: "12472", //生产状态
  orderType: "12471", //任务单类型
  platformModel: "12473", //平台型号
  priority: "12470", //优先级
  maintenanceMethodsType: "12466", // 维护方式
  simStatus: "12465", // SIM卡状态
  operStatus: "12481", // 运营商运营状态
  langObj: "12479", // 语言
  batchSettingObj: "166", //
  payMethodObj: "12489", // 微信支付可用渠道
  paymentChannel: "12547" // 支付渠道
};
/**
 * @author: xx
 * @description: 获取字典信息 typeIds是数组, 里面是 optionKey 对应的ID
 * @param {typeIds}
 * @return: Promise
 */
export const getOptionList = async (typeIds: string[]): Promise<objAny> => {
  const ret = await getDictItemAllList({
    typeIdList: typeIds
  });
  return new Promise<objAny>(resolve => {
    if (ret.status === config.apiStatus) {
      const list = ret.data;
      const obj: objAny = {};
      const language = localStorage.getItem("language") || "th-TH";
      typeIds.map(typeId => {
        list.map((item: objAny) => {
          if (item.typePkId == typeId) {
            if (!obj[typeId]) {
              obj[typeId] = [];
            }
            const value = item.i18nItemValue;
            item.label = value;
            item.itemValue = value;
            item.value = item.itemKey;
            obj[typeId].push(item);
          }
        });
      });
      resolve(obj);
    }
  });
};
